<template>
  <div class="wrapper-sidebar-for-me">
    <h2>{{ $tc(`${base}.title`, !isMobile) }}</h2>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LadSidebarForMe',
  data() {
    return {
      base: 'experience.is_for_me',
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
  },
}
</script>

<style lang="scss">
.wrapper-sidebar-for-me {
  padding-right: 15px;
}
</style>
